var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import cx from 'classnames';
import useUserPreference from '@parca/functions/useUserPreference';
var GenericInput = function (_a) {
    var id = _a.id, type = _a.type, value = _a.value, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    switch (type) {
        case 'boolean':
            return (_jsx("input", { className: "bg-inherit border disabled:cursor-not-allowed mt-[5px]", id: id, type: "checkbox", checked: value, onChange: function (e) { return onChange(e.target.checked); }, disabled: disabled }));
        case 'number':
            return (_jsx("input", { className: "bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-600 p-1 px-2 w-20 disabled:cursor-not-allowed rounded-md", id: id, type: "number", min: "0", value: value, onChange: function (e) { return onChange(Number(e.target.value)); }, disabled: disabled }));
    }
    return _jsx(_Fragment, {});
};
function UserPreferenceItem(_a) {
    var _b;
    var userPreferenceDetails = _a.userPreferenceDetails, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.labelToLeft, labelToLeft = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.inputSuffix, inputSuffix = _f === void 0 ? '' : _f;
    var _g = useUserPreference(userPreferenceDetails.key), enabledTrimming = _g[0], setEnabledTrimming = _g[1];
    return (_jsxs("div", __assign({ className: cx('flex gap-2 mb-1 items-start', (_b = {},
            _b[className] = className,
            _b['opacity-50'] = disabled,
            _b)) }, { children: [labelToLeft ? (_jsx("label", __assign({ htmlFor: userPreferenceDetails.key }, { children: userPreferenceDetails.name }))) : null, _jsx(GenericInput, { id: userPreferenceDetails.key, value: enabledTrimming, onChange: setEnabledTrimming, type: userPreferenceDetails.type, disabled: disabled }), inputSuffix.length > 0 ? _jsx("span", { children: inputSuffix }) : null, !labelToLeft ? (_jsx("label", __assign({ htmlFor: userPreferenceDetails.key }, { children: userPreferenceDetails.name }))) : null] })));
}
export default UserPreferenceItem;
